import React from 'react';
import {
  Box, Checkbox, InputLabel, withStyles,
} from '@material-ui/core';

const StyledCheckbox = withStyles({
  root: {
    '&$checked': {
      color: 'rgb(0,150,136)',
    },
  },
  checked: {},
})(Checkbox);

export default ({
  checked,
  fridgeName,
  id,
  onClick,
  productName,
  providerName,
}) => (
  <InputLabel htmlFor={id}>
    <Box display="flex" alignItems="center">
      <Box>
        <StyledCheckbox checked={checked} id={id} onChange={onClick} value={id} />
      </Box>
      <Box flexGrow={1} fontSize={16} color="black" fontWeight="bold">
        <Box>
          【
          {providerName}
          】
        </Box>
        <Box mt={1} pl={1.5}>{productName}</Box>
        <Box mt={1} pl={1.5} fontSize={12} color="rgb(104,104,104)" fontWeight="normal">
          該品項上架「
          {fridgeName}
          」主動通知您
        </Box>
      </Box>
    </Box>
  </InputLabel>
);
